import { hotTopics } from "../../../mocks/chiagua";

const rankColors = ["bg-primary-500", "bg-primary-400", "bg-secondary-500"];

export default function HotTopics() {
  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="text-accent-700 text-sm font-semibold tracking-widest">HOT TOPIC</span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-2">今日热榜</h2>
            <p className="text-foreground-600 text-sm md:text-base mt-3">
              实时讨论区热度最高的瓜，点进去边看边蹲反转。
            </p>
          </div>
          <a
            href="#live"
            className="hidden sm:inline-flex items-center gap-2 text-accent-700 hover:text-accent-800 text-sm font-medium whitespace-nowrap cursor-pointer"
          >
            去现场围观
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5 mt-8 md:mt-10">
          {/* 左侧榜单 */}
          <div className="lg:col-span-2 bg-background-50 border border-background-200/70 rounded-2xl p-4 md:p-5 flex flex-col gap-1">
            {hotTopics.map((t, i) => (
              <a
                key={t.id}
                href="#danmaku"
                className="group flex items-center gap-4 p-3 rounded-xl hover:bg-background-100/70 transition-colors cursor-pointer"
              >
                <span
                  className={`w-7 h-7 shrink-0 rounded-lg flex items-center justify-center text-background-50 text-sm font-bold ${
                    i < 3 ? rankColors[i] : "bg-background-300 text-foreground-600"
                  }`}
                >
                  {t.rank}
                </span>
                <span className="flex-1 min-w-0 text-foreground-900 font-medium text-sm md:text-base group-hover:text-primary-600 transition-colors line-clamp-2">
                  {t.title}
                </span>
                <span className="hidden md:inline-flex items-center gap-1 bg-background-200/60 text-foreground-600 text-xs px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.tag}
                </span>
                <span className="inline-flex items-center gap-1 text-foreground-500 text-xs shrink-0 whitespace-nowrap">
                  <i className="ri-fire-fill text-primary-500"></i>
                  {t.heat.toFixed(1)}万
                </span>
                {t.isNew && (
                  <span className="bg-accent-100 text-accent-800 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                    新爆
                  </span>
                )}
              </a>
            ))}
          </div>

          {/* 右侧热聊卡 */}
          <div className="bg-gradient-to-br from-primary-600 to-primary-500 rounded-2xl p-6 text-background-50 flex flex-col justify-between min-h-[220px]">
            <div>
              <span className="inline-flex items-center gap-2 text-primary-100 text-xs font-medium">
                <i className="ri-flashlight-line text-lg animate-flame"></i>
                正在发酵的瓜
              </span>
              <h3 className="font-heading text-2xl mt-3 leading-snug">
                全网都在问：这份声明到底回应了什么？
              </h3>
              <p className="text-primary-100/90 text-sm mt-3 leading-relaxed">
                截至目前相关话题阅读量已破 8000 万，实时讨论区观点两极，弹幕刷屏中。
              </p>
            </div>
            <div className="flex items-center justify-between mt-6">
              <span className="inline-flex items-center gap-1.5 text-primary-100 text-xs whitespace-nowrap">
                <i className="ri-eye-line"></i>
                5.6万人正在围观
              </span>
              <a
                href="#danmaku"
                className="bg-background-50 text-primary-600 text-sm font-semibold px-4 py-2 rounded-full whitespace-nowrap inline-flex items-center gap-1.5 hover:bg-background-100 transition-colors cursor-pointer"
              >
                去讨论
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}